<template>
    <v-row>
        <v-spacer />
        <material-card
            color="red"
            icon="$vuetify.icons.alien"
            icon-color="white"  
            style="position: relative;max-width: 500px"
        >
            <template #title>
                <v-card 
                    flat
                    style="position: sticky; top: 0;align-self: flex-start"
                >
                    <h1
                        style="font-weight: 300; font-family: lato; font-weight: bold; letter-spacing: initial;"
                    >
                        Access denied
                    </h1>
                    <h2 style="font-weight: 200">
                        Restricted space
                    </h2>                 
                </v-card>
            </template>
            <v-container>
                <v-card flat>
                    <h3 
                        style="font-weight: 400"
                        class="ml-1 mb-2 text-center"
                    >
                        Oh-oh... This area is forbidden for you!
                    </h3>
                    <v-card-actions>
                        <v-btn 
                            x-large
                            depressed
                            block
                            to="/"
                        >
                            Get me out of here
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-container>
        </material-card>    
        <v-spacer />
    </v-row>
</template>
<script>   
export default {
    name: 'AccessDenied',
}
</script>
